import { Switch, Route } from "react-router-dom";
import memoize from "lodash/memoize";

import Auth from "lib/auth";
import AuthContext, { IAuthContext } from "components/AuthContext";

import NotFound from "pages/NotFound";
import RegistrationPage from "pages/auth/Registration";
import Login from "pages/auth/Login";
import HomePage from "pages/home/HomePage";
import ProfilePage from "pages/profile/ProfilePage";
import DashboardPage from "pages/dashboard/DashboardPage";
// import NewsPage from "pages/news/NewsPage";
// import SponsorPage from "pages/sponsors/SponsorPage";
// import LivePage from "pages/live-page/LivePage";
import StatsPage from "pages/profile/StatsPage";
import SettingsPage from "pages/profile/SettingsPage";
import ProtectedRoute from "components/ProtectedRoute";
import GamesPage from "pages/games/GamesPage";
import IndividualGamePage from "pages/games/IndividualGamePage";
import TournamentsPage from "pages/tournament/TournamentsPage";
import TournamentPage from "pages/tournament/TournamentPage";
import LeaderboardPage from "pages/leaderboard/LeaderboardPage";
import ResetPasswordPage from "pages/auth/ResetPassword";
import { useGetMeQuery } from "generated/graphql";
import { LoggedInUserContext } from "contexts/user";
import SetNewPasswordPage from "pages/auth/SetNewPassword";
import HubsPage from "pages/hubs/HubsPage";

const auth = new Auth();

function App() {
  const { data, error } = useGetMeQuery({ nextFetchPolicy: "cache-first"});

  const token = auth.getToken();

  const authContext = memoize(
    (): IAuthContext => ({
      isAuthenticated: Boolean(token),
      // @ts-ignore
      user: token,
    })
  )();


  return (
    <AuthContext.Provider value={authContext}>
      <LoggedInUserContext.Provider
        value={!error && data ? data.me : undefined}
      >
        <Switch>
          <Route path="/" component={HomePage} exact />
          {/* <Route path="/news" component={NewsPage} /> */}
          {/* <Route path="/sponsor-page" component={SponsorPage} /> */}
          {/* <Route path="/live-page" component={LivePage} /> */}
          <Route path="/u/:username" component={ProfilePage} />
          <Route path="/games" exact component={GamesPage} />
          <Route path="/games/:gameId" exact component={IndividualGamePage} />
          <Route path="/tournaments" exact component={TournamentsPage} />
          <Route path="/hub-registration" exact component={HubsPage} />
          <Route
            path="/tournaments/:tournamentId"
            exact
            component={TournamentPage}
          />

          <Route path="/leaderboard" component={LeaderboardPage} />
          <Route path="/auth/login" component={Login} />
          <Route path="/auth/register" component={RegistrationPage} />
          <Route path="/auth/reset-password" component={SetNewPasswordPage} />
          <Route path="/auth/forgot-password" component={ResetPasswordPage} />

          <ProtectedRoute path="/dashboard">
            {(props: any) => <DashboardPage {...props} />}
          </ProtectedRoute>
          <ProtectedRoute path="/profile/:username" exact>
            {(props: any) => <ProfilePage isSelf={true} {...props} />}
          </ProtectedRoute>
          <ProtectedRoute path="/profile/:username/stats">
            {(props: any) => <StatsPage {...props} />}
          </ProtectedRoute>
          <ProtectedRoute path="/settings">
            {(props: any) => <SettingsPage {...props} />}
          </ProtectedRoute>
          <Route path="*" component={NotFound} exact />
        </Switch>
      </LoggedInUserContext.Provider>
    </AuthContext.Provider>
  );
}

export default App;
